<template>
  <div class="px-6 py-16 bg-white lg:px-8">
    <title>Privacy Policy - Rajdoot Services</title>
    <div class="max-w-5xl mx-auto text-base leading-7 text-gray-700">
      <h1
        class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
      >
        Privacy Policy
      </h1>
      <p class="mt-4 text-xl leading-8">
        Rajdoot Services - Privacy Policy
      </p>
      <p class="mt-3 text-xl font-bold leading-8">
        Effective Date: 1st July 2024
      </p>

      <section class="mt-2 mb-6">
        <h2 class="text-xl font-semibold text-blue-600 mb-2">
          1. Information We Collect
        </h2>
        <p class="text-gray-700 leading-relaxed">
          We collect the following types of information:
        </p>
        <ul class="list-disc list-inside text-gray-700 mt-2">
          <li>
            <strong>Personal Information:</strong> Name, address, phone number,
            and email address.
          </li>
          <li>
            <strong>Service Details:</strong> Information about the appliances
            or electrical systems requiring repair.
          </li>
        </ul>
      </section>
      <section class="mb-6">
        <h2 class="text-xl font-semibold text-blue-600 mb-2">
          2. How We Use Your Information
        </h2>
        <p class="text-gray-700 leading-relaxed">
          Your information is used to:
        </p>
        <ul class="list-disc list-inside text-gray-700 mt-2">
          <li>Schedule and provide services.</li>
          <li>Contact you regarding your service requests.</li>
          <li>Generate bills and process payments.</li>
          <li>Improve our services and website.</li>
        </ul>
      </section>
      <section class="mb-6">
        <h2 class="text-xl font-semibold text-blue-600 mb-2">
          3. Information Sharing
        </h2>
        <p class="text-gray-700 leading-relaxed">
          We do not share your personal information with third parties, except:
        </p>
        <ul class="list-disc list-inside text-gray-700 mt-2">
          <li>To comply with legal obligations.</li>
          <li>
            To trusted vendors or suppliers necessary for completing your
            service.
          </li>
        </ul>
      </section>
      <section class="mb-6">
        <h2 class="text-xl font-semibold text-blue-600 mb-2">
          4. Data Security
        </h2>
        <p class="text-gray-700 leading-relaxed">
          We implement industry-standard measures to protect your data from
          unauthorized access, loss, or misuse.
        </p>
      </section>
      <section class="mb-6">
        <h2 class="text-xl font-semibold text-blue-600 mb-2">5. Your Rights</h2>
        <p class="text-gray-700 leading-relaxed">
          You have the right to:
        </p>
        <ul class="list-disc list-inside text-gray-700 mt-2">
          <li>Access, update, or delete your personal information.</li>
          <li>
            To exercise these rights, contact us at
            <strong>+91 8237 478 645</strong>.
          </li>
        </ul>
      </section>
      <section class="mb-6">
        <h2 class="text-xl font-semibold text-blue-600 mb-2">6. Cookies</h2>
        <p class="text-gray-700 leading-relaxed">
          Our website may use cookies to enhance your browsing experience. You
          can disable cookies through your browser settings if you prefer.
        </p>
      </section>
      <section class="mb-6">
        <h2 class="text-xl font-semibold text-blue-600 mb-2">
          7. Changes to the Privacy Policy
        </h2>
        <p class="text-gray-700 leading-relaxed">
          We reserve the right to update this Privacy Policy at any time.
          Changes will be posted on this page, and your continued use of our
          services constitutes acceptance of those changes.
        </p>
      </section>
      <section>
        <h2 class="text-xl font-semibold text-blue-600 mb-2">8. Contact Us</h2>
        <p class="text-gray-700 leading-relaxed">
          If you have any questions or concerns about this Privacy Policy,
          please contact us:
        </p>
        <address class="text-gray-700 mt-2">
          <strong>Rajput Electricals</strong><br />
          Phone: +91 823 747 8645<br />
        </address>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
